import { VuexModule, Module, Mutation } from "vuex-module-decorators";
import Vue from "vue";

@Module({ namespaced: true })
export default class FormModule extends VuexModule {
  currentStep: number = 1;
  steps: Array<Step> = [];
  loading: boolean = false;
  status: number = 0;
  errors: object = {};
  formDisabled: boolean = false;
  // title: string = ''

  @Mutation setCurrentStep(step: number) {
    this.currentStep = step;
  }

  // @Mutation setTitle(title: string) {
  //   this.title = title;
  // }

  @Mutation setLoading(loading: boolean) {
    this.loading = loading;
  }

  @Mutation setSteps(steps: Array<Step>) {
    this.steps = steps;
    this.currentStep = 1;
  }

  @Mutation setStatus(status: number) {
    this.status = status;
  }

  @Mutation setError(error: Error) {
    Vue.set(this.errors, error.path, error.msg);
  }

  @Mutation resetErrors() {
    Vue.set(this, "errors", {});
  }

  @Mutation enableStep(idx: number) {
    this.steps[idx - 1].enabled = true;
  }

  @Mutation disableStep(idx: number) {
    this.steps[idx - 1].enabled = false;
  }

  @Mutation enableAllSteps() {
    this.steps.map((step: Step) => (step.enabled = true));
  }

  @Mutation setDisabled(disabled: boolean) {
    this.formDisabled = disabled;
  }

  @Mutation setStep(step: number) {
    if (step > 0 && step <= this.total) {
      this.currentStep = step;
    }
  }

  @Mutation nextStep() {
    if (this.currentStep < this.total) {
      this.currentStep += 1;
    }
  }

  @Mutation previousStep() {
    if (this.currentStep > 1) {
      this.currentStep -= 1;
    }
  }

  @Mutation disableAllSteps() {
    for (let step = 0; step <= this.steps.length; step++) {
      this.disableStep(step);
    }
  }

  get title(): string {
    return this.total > 0 ? this.steps[this.currentStep - 1].title : "";
  }

  get total(): number {
    return this.steps.length;
  }

  get isLast(): boolean {
    return this.currentStep == this.steps.length;
  }

  get isFirst(): boolean {
    return this.currentStep == 1;
  }

  get getError(): any {
    const errors = this.errors;
    return function(path: string) {
      return (errors as any)[path];
    };
  }

  get isEnabled() {
    return function(step: number) {
      const steps: Array<any> = this.steps;
      return step > 0 && step <= this.total ? steps[step - 1].enabled : null;
    };
  }
}
